/**
 * ExposePublic — Öffentliche Route /expose/:token.
 *
 * Verhalten: Direkter Browser-Redirect zu /api/expose/:token/html (Backend
 * liefert das statische HTML). Kein React-State, keine Race-Condition, kein
 * iframe. Bei ungültigem/abgelaufenem Token liefert das Backend selbst eine
 * navy-branded Fehlerseite (`_expiry_page` in expose.py).
 *
 * Vorteil ggü. iframe-Ansatz: robust gegen Auth-Context-Rerender, keine
 * CORS/withCredentials-Konflikte, kein hängender Loading-Screen bei
 * verzögerten Meta-Antworten.
 */
import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { API } from "../lib/api";

export default function ExposePublic() {
  const { token } = useParams();
  const location = useLocation();

  useEffect(() => {
    if (!token) return;
    // Query-Parameter durchreichen (z.B. ?lang=en für Sprach-Toggle)
    const search = location.search || "";
    window.location.replace(`${API}/expose/${token}/html${search}`);
  }, [token, location.search]);

  // Fallback-Zwischenscreen im gleichen CI, falls das Navigate 1-2 Frames
  // dauert. Bei aktivem Redirect ist er sofort wieder weg.
  return (
    <div
      className="fixed inset-0 flex items-center justify-center"
      style={{ background: "#022750", color: "white" }}
      data-testid="expose-public-redirect"
    >
      <div className="flex items-center gap-3">
        <div
          style={{
            width: 14,
            height: 14,
            border: "2px solid #C4922A",
            borderTopColor: "transparent",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />
        <span
          style={{
            fontFamily: "'Inter', system-ui, sans-serif",
            fontSize: 12,
            letterSpacing: 2,
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.8)",
          }}
        >
          Exposé wird geöffnet…
        </span>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
